export default class ValueRankingActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';

  static SET_HELPER='SET_HELPER'
  static setHelper(data){
    return {
      type: ValueRankingActions.SET_HELPER,
      payload:data
    };
  }

  static submit(){
    return {
      type: ValueRankingActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: ValueRankingActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: ValueRankingActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: ValueRankingActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: ValueRankingActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: ValueRankingActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: ValueRankingActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: ValueRankingActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: ValueRankingActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: ValueRankingActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: ValueRankingActions.RESET_DATA,
    };
  }
  static errorInternal(error){
    return {
      type: ValueRankingActions.ERROR_SERVER,
      payload: error
    };
  }
}